






















import { Component, Vue, Watch } from "vue-property-decorator";
import { AuthModule } from "@/store/auth.module";
import { AppealsModule } from "@/store/appeals.module";
import DatePicker from "@/components/ui/DatePicker.vue";
import moment from "moment";
import { translate } from "@/utils";
import { Appeal, AppealDTO, AppealStatus } from "../../../../lib/appeal.type";
import TableCellTooltip from "@/components/ui/TableCellTooltip.vue";
import AppealsIn from "./AppealsIn.vue";
import AppealsOut from "@/views/Contract/Menu/AppealsOut.vue";

@Component({
  components: { DatePicker, TableCellTooltip, AppealsIn, AppealsOut },
})
export default class Appeals extends Vue {
  newAppeal() {
    AppealsModule.newAppeal();
  }

  get statusList() {
    return translate(AppealsModule.appealStatusList);
  }

  get tab() {
    return AppealsModule.tab;
  }

  set tab(val) {
    AppealsModule.setTab(val);
  }

  async mounted() {
    await AppealsModule.loadSatatuses(1);
    await AppealsModule.loadTypes();
  }
}
